import { cardPageController, translate } from 'magner';
import { QrCode } from 'features/settings/qr-code/types';
import { getQrCode, updateQrCode, deleteQrCode } from 'features/settings/qr-code/requests';
import { ActionButton } from 'magner/dist/types/utils/actions';

const qrCodeConfig = cardPageController<QrCode>({
  header: {
    title: translate('hubstr.qr_code.sidebar.card_title'),
  },

  getRequest: getQrCode,
  createRequest: null,
  updateRequest: updateQrCode,
  deleteRequest: deleteQrCode,

  confirmDelete: translate('hubstr.qr_code.form.confirm_delete'),

  form: {
    fullDataOnUpdate: true,
    actions: [
      {
        type: 'action',
        emits: 'cancel',
        props: {
          text: translate('hubstr.qr_code.form.cancel_button'),
        },
      } as ActionButton<'cancel'>,
      {
        type: 'action',
        emits: 'submit',
        props: {
          text: translate('hubstr.qr_code.form.submit_button'),
          type: 'primary',
        },
      } as ActionButton<'submit'>,
      {
        type: 'action',
        emits: 'remove',
        props: {
          text: translate('hubstr.qr_code.form.remove_button'),
          type: 'danger',
        },
      },
    ],

    layout: {
      type: 'column',
      props: {},
      fields: [
        {
          type: 'dropzone',
          name: 'image',
          label: translate('hubstr.qr_code.form.image.label'),
          hint: translate('hubstr.qr_code.form.image.hint'),
          props: {
            required: true,
            formats: ['jpg', 'jpeg', 'png'],
            removable: true,
            valueKey: 'id',
            srcKey: 'image',
            maxSize: 8,
          },
          validation: [{
            type: 'empty-required' as 'empty',
            trigger: 'change',
          }],
        },
      ],
    },
  },
});

export default qrCodeConfig;
